import React, { useEffect, useState } from "react";
import useHttp from "../../hooks/use-http";
import { Area, Column, Pie } from "@ant-design/plots";

const SalesDashborad = () => {
  const [data, setData] = useState([]);
  const [lastOrders, setLastOrders] = useState([]);
  const [lastRevenues, setLastRevenues] = useState([]);
  const [lastRevenuesReturn, setLastRevenuesReturn] = useState([]);
  const [orderStatus, setOrderStatus] = useState([]);

  const { sendRequest: getData } = useHttp();
  useEffect(() => {
    getData(
      {
        url: `/api/salesDashboradStacks/?orgId=${localStorage.getItem(
          "orgId"
        )}&&empId=${localStorage.getItem("empId")}`,
      },
      (data) => {
        setData(data);
        setLastOrders(data.pastSixMonthsOrders);
        setLastRevenues(data.pastSixMonthsRevenuesReturns);
        const orderData = [
          {
            type: "Paid",
            value: data.orderStatus.currentMonthOrdersWithInvoices || 0,
          },
          {
            type: "Unpaid",
            value: data.orderStatus.currentMonthOrdersWithoutInvoices || 0,
          },
        ];
        setOrderStatus(orderData);

        const transformedData = data?.pastSixMonthsRevenuesReturns.flatMap(
          (item) => [
            { month: item.month, type: "Revenue", value: item.revenue },
            {
              month: item.month,
              type: "Return Revenue",
              value: item.returnRevenue,
            },
          ]
        );
        setLastRevenuesReturn(transformedData);
       // console.log(data);
      }
    );
  }, [getData]);

  const sixMonthOrdersConfig = {
    data: lastOrders,
    xField: "month",
    yField: "orderCount",
    xAxis: {
      label: {
        autoHide: true,
        autoRotate: false,
      },
    },
    yAxis: {
      label: {
        formatter: (v) => `${v}`,
      },
    },
    // smooth: true,
    areaStyle: () => {
      return { fill: "grey" };
    },
    point: {
      size: 1,
      shape: "circle",
      style: {
        fill: "white",
        stroke: "#5B8FF9",
        lineWidth: 2,
      },
    },
  };

  const orderStatusConfig = {
    data: orderStatus,
    angleField: "value",
    colorField: "type",
    color: ({ type }) => {
      if (type === "Paid") return "#5B8FF9";
      if (type === "Unpaid") return "#CDDDFD";
      return "gery"; // Default color (optional)
    },
    padding: "auto",
    innerRadius: 0.6,
    label: {
      type: "inner",
      offset: "-50%",
      content: "{value}",
      style: {
        fontWeight: "bold",
        textAlign: "center",
      },
    },
    legend: {
      position: "right",
      itemName: {
        style: {
          fontWeight: "bold",
        },
      },
    },
    annotations: [
      {
        type: "text",
        position: ["50%", "50%"],
        // content: '',
        style: {
          fontSize: 40,
          fontWeight: "bold",
          textAlign: "center",
        },
      },
    ],
  };

  const sixMonthRevenueConfig = {
    data: lastRevenues,
    xField: "month",
    yField: "revenue",
    label: {
      position: "middle",

      style: {
        fill: "#FFFFFF",
        opacity: 0.6,
      },
    },
    xAxis: {
      label: {
        // autoHide: true,
        autoRotate: false,
        rotate: 220,
      },
      title: {
        text: "Revenue",
      },
    },
    yAxis: {
      title: {
        text: "Month",
      },
    },
    scrollbar: {
      type: "horizontal",
    },
    meta: {
      revenue: {
        alias: "Revenue",
      },
    },
  };

  const config = {
    data: lastRevenuesReturn,
    isGroup: true,
    xField: "month",
    yField: "value",
    seriesField: "type",
    dodgePadding: 2,
    intervalPadding: 10,
    columnStyle: {
      radius: [0, 0, 0, 0],
    },
    legend: { position: "top" },
  };

  return (
    <>
      <div className="content-wrapper">
        {/* Content Header (Page header) */}
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6"></div>
              <div className="col-sm-6"></div>
            </div>
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-4 col-6">
                <div className="small-box bg-warning">
                  <div className="inner">
                    <h3>{(data && data.currentMonthCustomers) || 0}</h3>

                    <p>Current Month Customers</p>
                    <p>Last Month : {(data && data.lastMonthCustomers) || 0}</p>
                  </div>

                  <div className="icon">
                    <i className="ion ion-person-add"></i>
                  </div>
                </div>
              </div>

              <div className="col-lg-4 col-6">
                <div className="small-box bg-info">
                  <div className="inner">
                    <h3>{(data && data.currentMonthOrders) || 0}</h3>

                    <p>Current Month Orders</p>
                    <p>Last Month : {(data && data.lastMonthOrders) || 0}</p>
                  </div>
                  <div className="icon">
                    <i className="fas fa-shopping-cart"></i>
                  </div>
                </div>
              </div>

              <div className="col-lg-4 col-6">
                <div className="small-box bg-success">
                  <div className="inner">
                    <h3>
                      {parseFloat(data && data.currentMonthRevenue).toFixed(
                        2
                      ) || 0}{" "}
                      {data?.currencyCode || ""}
                    </h3>

                    <p>Current Month Revenue</p>
                    <p>Last Month : {(data && data.lastMonthRevenue) || 0}</p>
                  </div>
                  <div className="icon">
                    <i className="fas fa-chart-pie"></i>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-4 col-6">
                <div className="small-box bg-fuchsia">
                  <div className="inner">
                    <h3>{(data && data.currentMonthSalesReturns) || 0}</h3>

                    <p>Current Month Sales Return</p>

                    <p>
                      Last Month : {(data && data.lastMonthSalesReturns) || 0}
                    </p>
                  </div>
                  <div className="icon">
                    <i className="fas fa-sync-alt"></i>
                  </div>
                </div>
              </div>

              <div className="col-lg-4 col-6">
                <div className="small-box bg-maroon">
                  <div className="inner">
                    <h3>
                      {(data && data.currentMonthProfit) || 0}{" "}
                      {data?.currencyCode}
                    </h3>

                    <p>Profit</p>
                    <p>
                      Last Month Profit : {(data && data.lastMonthProfit) || 0}
                    </p>
                  </div>
                  <div className="icon">
                    <i className="fas fa-coins"></i>
                  </div>
                </div>
              </div>

              <div className="col-lg-4 col-6">
                <div className="small-box bg-lightblue">
                  <div className="inner">
                    <h3>{(data && data.currentMonthExpenses) || 0}</h3>

                    <p>Expances</p>
                    <p>
                      Last Month Expances :{" "}
                      {(data && data.lastMonthExpenses) || 0}
                    </p>
                  </div>
                  <div className="icon">
                    <i className="ion ion-stats-bars"></i>
                  </div>
                </div>
              </div>
            </div>
            <div className="row text-center">
              <div className="col-md-6 col-12 col-sm-12">
                <div className="card card-primary shadow">
                  <div className="card-header">
                    <h3 className="card-title">Orders:last 6 month</h3>

                    <div className="card-tools">
                      <button
                        type="button"
                        className="btn btn-tool"
                        data-card-widget="maximize"
                      >
                        <i className="fas fa-expand"></i>
                      </button>
                    </div>
                  </div>

                  <div className="card-body">
                    <div style={{ width: "80%" }}>
                      <Area {...sixMonthOrdersConfig} />
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-12 col-sm-12">
                <div className="card card-primary shadow">
                  <div className="card-header">
                    <h3 className="card-title">Order Status</h3>

                    <div className="card-tools">
                      <button
                        type="button"
                        className="btn btn-tool"
                        data-card-widget="maximize"
                      >
                        <i className="fas fa-expand"></i>
                      </button>
                    </div>
                  </div>

                  <div className="card-body">
                    <div style={{ width: "80%" }}>
                      <Pie {...orderStatusConfig} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row text-center">
              <div className="col-md-6 col-12 col-sm-12">
                <div className="card card-primary shadow">
                  <div className="card-header">
                    <h3 className="card-title">Revenue</h3>

                    <div className="card-tools">
                      <button
                        type="button"
                        className="btn btn-tool"
                        data-card-widget="maximize"
                      >
                        <i className="fas fa-expand"></i>
                      </button>
                    </div>
                  </div>

                  <div className="card-body">
                    <div style={{ width: "80%" }}>
                      <Column {...sixMonthRevenueConfig} />
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-12 col-sm-12">
                <div className="card card-primary shadow">
                  <div className="card-header">
                    <h3 className="card-title">Order Revenue Vs Refunds</h3>

                    <div className="card-tools">
                      <button
                        type="button"
                        className="btn btn-tool"
                        data-card-widget="maximize"
                      >
                        <i className="fas fa-expand"></i>
                      </button>
                    </div>
                  </div>

                  <div className="card-body">
                    <div style={{ width: "80%" }}>
                      <Column {...config} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default SalesDashborad;
